import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { AuthService, DBService, DownLoadService } from '../../service';
import { Router } from '@angular/router';
import { DropDownService } from '../../service/drop-down.service';
import { StorageService } from '../../service/storage.service';
import { User } from '../../model/types';
import {AnalysisKey, AuthLog, Logs, PreviousAnalysis, RDSAnalysisData} from '../../model/analysis-details.model';
import Utils from '../../utility/Utils';
import { MatDatepicker } from '@angular/material/datepicker';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import _moment from 'moment';
import {default as _rollupMoment, Moment} from 'moment';
import { FormControl } from '@angular/forms';
const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
  providers: [ {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS}
  ]
})
export class UserComponent implements OnInit {
  date = new FormControl(moment());
  startDate;
  endDate;
  role;
  pageTitle = 'User Account';
  signedInUser: any;
  loading = false;
  username: string;
  email: string;
  users: any[] = [];
  previousAnalysisKeys: RDSAnalysisData[] = [];
  logdata: AuthLog[] = [];
  illegalUser: boolean;
  auditFlag: boolean = false;

  maxYear;
  temp_loginData: any;
  temp_analysisData: any;
  title = 'Loading';
  @ViewChild('datePicker') public dp;



  constructor(private _sharedService: SharedService,
    private authService: AuthService,
    private storageService: StorageService,
    private router: Router,
    private dbService: DBService,
    private dropDownService: DropDownService,
    private downloadService: DownLoadService) {
     
    this.dbService.rdsAnalysisData.subscribe(
        (data: RDSAnalysisData[]) => {
         
          this.previousAnalysisKeys = data;
//           console.log('RDS Analysis Data on Audit page',this.previousAnalysisKeys );
        }
    );
   
    // this.dbService.authLogs.subscribe(
    //     (data: AuthLog[]) => {
    //       console.log('logdata DATA from Subscription', data)
    //       this.logdata = data;
    //       console.log("yyy",this.logdata)
    //     }
    // );
    this._sharedService.emitChange(this.pageTitle);
  }


  ngOnInit(): void {
    const currentYear = moment().toDate();
    this.maxYear = currentYear;
    this.role = this.storageService.get('access');
    this.authService.getCurrentUser((err, user: User) => {
      this.signedInUser = user;
      if (!this.signedInUser || !this.signedInUser.signedIn) {
        this.router.navigate(['/extra-layout/signin']);
        return;
      } else {
        this.authService.getUserAttributes((err1, userAttributes) => {
          this.loading = false;
          if (err1 || !userAttributes) {
            // console.error(err, new Error('Unable to retrieve user attributes.'));
            this.router.navigate(['/extra-layout/signin']);
          }
        });

        if (this.role == 'GA' || this.role == 'RV' || this.role == 'SU') {
          this.illegalUser = false;
          this.auditFlag = true;
          this.dbService.getAnalysis(this.role,this.startDate,this.endDate, this.auditFlag);
        } else {
          this.illegalUser = true;
        }
       }
    });
  }

 passSelectedDates() {
  this.previousAnalysisKeys = []

 const data = this.dbService.getAnalysis(this.role, this.startDate, this.endDate)
//  console.log(data)
}

  selectedDates(dateRangeStart, dateRangeEnd){
    this.startDate = dateRangeStart.value;
    this.endDate = dateRangeEnd.value;
    this.passSelectedDates();
//     console.log(this.startDate);
//     console.log(this.endDate);
  }
}


